import { Box } from '@mui/system';
import { ClientSchemaType, ModalBase } from 'remote/global';

import { useTranslation } from 'react-i18next';
import MyClientsRequestForm from '../forms/B2BFactory/MyClientsRequestForm';

type B2BClientRequestModalProps = Omit<
  React.ComponentProps<typeof MyClientsRequestForm>,
  'closeDialog'
> & {
  defaultValues?: ClientSchemaType;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
};

function B2BClientRequestModal(props: B2BClientRequestModalProps) {
  const { t } = useTranslation();
  const { open, setOpen, onClose, ...rest } = props;

  const isEditMode = rest.defaultValues?.id != null;

  return (
    <ModalBase
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      maxWidth='sm'
      title={
        isEditMode
          ? t('modals.supplierContractRequest.titleEdit').toString()
          : t('modals.supplierContractRequest.title').toString()
      }
      fullWidth
      preventCloseOutside
    >
      <Box sx={{ p: { xs: 1, sm: 2, md: 3, zIndex: 0 } }}>
        <MyClientsRequestForm {...rest} onClose={onClose} />
      </Box>
    </ModalBase>
  );
}

export default B2BClientRequestModal;
